import {ImageListDotIndicators} from './dot-indicators';
import {ImageListForwardButton} from './forward-button';
import {ImageListHeading} from './heading';
import {ImageListItem} from './item';
import {ImageListList} from './list';
import {ImageListBackButton} from './back-button';
import {ImageListRoot} from './root';
import {ImageListTop} from './top';

export const imageList = {
  heading: ImageListHeading,
  root: ImageListRoot,
  top: ImageListTop,
  list: ImageListList,
  item: ImageListItem,
  backButton: ImageListBackButton,
  forwardButton: ImageListForwardButton,
  dotIndicators: ImageListDotIndicators,
};
